import React from 'react';
import { Controller } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';

export const FormInputCheckbox = ({
  name,
  label,
  errors,
  control,
  disabled = false,
}) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            sx={{
              display: 'flex',
              alignItems: 'start',
              placeItems: 'anchor-center',
              '& .MuiFormControlLabel-label': {
                fontWeight: 410,
                fontSize: '0.95rem',
              },
            }}
            control={
              <Checkbox
                {...field}
                checked={!!field.value}
                disabled={disabled}
                onChange={(e) => field.onChange(e?.target?.checked)}
              />
            }
            label={label}
          />
        )}
      />
      {errors?.[name] && (
        <Typography color="error" variant="caption">
          {errors[name].message}
        </Typography>
      )}
    </>
  );
};
